module.exports = __webpack_public_path__ + "img/index.4809ff29.png";